import React from "react";

/**
 * The header every screen opens with: what you are looking at, how many of
 * them, and the actions for this page.
 */
const PageHeader = ({ icon, title, subtitle, count, children }) => (
  <div className="page-head">
    {icon && (
      <span className="page-head__icon">
        <i className={icon} />
      </span>
    )}
    <div className="page-head__text">
      <h4 className="page-head__title">
        {title}
        {count !== undefined && count !== null && (
          <span className="page-head__count">{count}</span>
        )}
      </h4>
      {subtitle && <span className="page-head__subtitle">{subtitle}</span>}
    </div>
    <div className="page-head__spacer" />
    {children && <div className="page-head__actions">{children}</div>}
  </div>
);

export default PageHeader;
